import { state } from '@angular/animations';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDate} from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { GeneralService } from 'src/app/Service/general.service';
import { ChartType } from 'src/app/core/models/chart-type';
import Swal from 'sweetalert2';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import * as moment from 'moment';


class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
@Component({
  selector: 'app-franchise-dashboard',
  templateUrl: './franchise-dashboard.component.html',
  styleUrls: ['./franchise-dashboard.component.scss']
})
export class FranchiseDashboardComponent implements OnInit {
  @ViewChild('content', { static: false }) content: TemplateRef<any>;
  @ViewChild('content1', { static: false }) content1: TemplateRef<any>;
  public daterange: any = {};
  dateRangeForm: FormGroup;
  SelectedDate: Date = new Date();
  ChartType2: ChartType;
  ChartType1: ChartType;
  usersCount: any;
  isLoading: boolean = false;
  currentUser: any;
  totalUsersCount: number;
  activeUsersCount: number;
  zeroUsersCount: number;
  inactiveUsersCount: number;
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  UserId: any;
  lables: any[];
  series: any[];
  amountGraphDate: any;
  series2: any[];
  lables2: string[];
  dateRangeValue:string;

  fromDate: Date;
  toDate: Date;
  fromNGDate: NgbDate;
  toNGDate: NgbDate;
  @Output() dateRangeSelected: EventEmitter<{}> = new EventEmitter();
  selected: any;
  hidden: boolean;
  receiptGraphObj: { 'Fresh': number, 'Land Record': number, 'Renewal': Number, 'Top UP': number };
  userGraphObj: { 'Inactive': number, 'Deactivated': number, 'Active': number, 'Spam': number, 'Zero': number, 'Unregistered': number };
  deactivatedUser: any;
  name: string;
  options={};
  dates: { endDate: string; startDate: string; };
  constructor(private dialog: MatDialog, private formBuilder: FormBuilder,
    private datePipe: DatePipe,private daterangepickerOptions: DaterangepickerConfig,
    private generalService: GeneralService, private titlecasePipe: TitleCasePipe, private http: HttpClient, private router: Router) {
     
      this.daterangepickerOptions.settings = {
        showDropdowns: true,
        alwaysShowCalendars: false,
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: 'Apply',
          cancelLabel: '',
          daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          monthNames: [
            'January',
            'Feburary',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ],
          firstDay: 1
        }
      };
  }
  ngOnInit() {
    this.options = {
      opens: 'left', // Position of the calendar relative to the input field
      minDate: moment().subtract(2, 'year'), // Minimum selectable date
      maxDate: moment().add(2, 'year'), // Maximum selectable date
      showDropdowns: true, // Display month and year dropdowns
      autoUpdateInput: false, // Prevents the input field from being automatically updated with the selected date range
      ranges: {
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'Last 6 Months': [moment().subtract(6, 'months'), moment()],
        'Last 1 Year': [moment().subtract(1, 'year'), moment()],
        'Last 2 Years': [moment().subtract(3, 'year'), moment()],
      },
    };
    this.receiptGraphObj = { 'Fresh': 0, 'Land Record': 0, 'Renewal': 0, 'Top UP': 0 };
    this.userGraphObj = { 'Inactive': 0, 'Deactivated': 0, 'Active': 0, 'Spam': 0, 'Zero': 0, 'Unregistered': 0 };
   this.selected = '';
   this.hidden = true;
   this.currentUser = this.generalService.getcurrentUser();
   this.getCountOfUser();
   this.getAmountGraphData();
   this.setChartData1();
   this.setChartData2();
   this.isLoading = true;
   this.dtOptions = {
     pagingType: "simple_numbers",
     pageLength: 10,
     processing: true,
     serverSide: true,
     ordering: false,
     ajax: (dataTablesParameters: any, callback) => {

       this.http
         .get<DataTablesResponse>(
           `${this.generalService.getallusers()}/${dataTablesParameters.search.value != '' ? dataTablesParameters.search.value + '/' : ''}${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}/${dataTablesParameters.length}`,
           {}
         ).subscribe(resp => {
           if (resp.data.length) {
             this.isLoading = false;
             callback({
               recordsTotal: resp.data[0].total,
               recordsFiltered: `${resp.data[0].filtercount ? resp.data[0].filtercount : resp.data[0].total}`,
               data: resp.data
             });
           }
           else {
             this.isLoading = false;
             callback({
               recordsTotal: resp.data.length,
               recordsFiltered: resp.data.length,
               data: resp.data
             });
           }

         });
     },
     responsive: true,
     columns: [
       {
         title: 'Sr.No.',
         data: null,
         render: (data, type, row, meta) => {
           return meta.row + 1;
         },
       },
       {
         title: 'User ID',
         data: null,
         render: (data) => {
           return data.id;
         },
       },
       {
         title: 'Name',
         data: null,
         render: (data) => {
           return data.firstname + ' ' + data.lastname;
         },
       },
       {
         title: 'Mobile Number',
         data: null,
         render: (data) => {
           return data.mobileno;
         },
       },
       {
         title: 'Email',
         data: null,
         render: (data) => {
           return data.email;
         }
       },
       {
         title: 'Status',
         data: 'status',
       },
       {
         title: 'Action',
         data: null,
         render(data) {
           return `<div style="display:flex" >
           <a class="btn text-primary view" title="View">
           <i class="btn font-18 mdi mdi-eye-outline text-secondary" UserID="${data.id}" PlanID="${data.plan}"></i></a>
         `;
         },
       },
     ],

     drawCallback: () => {
       $('.view').on('click', (e) => {
         this.UserId = e.target.getAttribute('UserId');
         this.openDialog1(e.target.getAttribute('UserId'));
         // this.router.navigate(['franchise/franchise-users']);
       });
     },
   };
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  getCountOfUser(Dates?: any) {
    this.isLoading = true;
    this.userGraphObj = { 'Inactive': 0, 'Deactivated': 0, 'Active': 0, 'Spam': 0, 'Zero': 0, 'Unregistered': 0 };
    this.usersCount = [];
    this.generalService.getCountOfUser(this.currentUser.franchise_Id, Dates).subscribe((res: any) => {
      if (res) {
        this.isLoading = false;
        this.usersCount = res.data;
        this.setCount(this.usersCount['status_wise_count']);
        let temp = Object.values(this.usersCount['status_wise_count']);
        this.lables = temp.map((i: any) => {
          this.userGraphObj[this.titlecasePipe.transform(i.status)] = i.count ? i.count : 0;
        })
        this.setChartData1()
      }
      
    },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      })
  }

  setCount(data: any) {
    this.inactiveUsersCount = 0;
    this.activeUsersCount = 0;
    this.zeroUsersCount = 0;
    this.deactivatedUser = 0;
    if (data.length) {
      data.forEach((i) => {
        if (i.status === "inactive") {
          this.inactiveUsersCount = i.count;
        }
        else if (i.status === 'active') {
          this.activeUsersCount = i.count;
        }
        else if (i.status === 'zero') {
          this.zeroUsersCount = i.count;
        }
        else if (i.status === 'deactivated') {
          this.deactivatedUser = i.count;
        }
      })
    }

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.content, {
      width: '600px',
      data: {},
      autoFocus: false,
      maxHeight: '90vh',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  openDialog1(userId: any): void {
    this.UserId = userId;
    const dialogRef = this.dialog.open(this.content1, {
      width: '600px',
      data: {},
      autoFocus: false,
      maxHeight: '90vh',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  close() {
    this.dialog.closeAll();
  }


  viewReceipt() {
    this.router.navigate([
      'user/receipts/' + this.UserId,
    ]);
  }
  callAlert() {
    this.router.navigate(['/users/call-alert'], { state: { id: this.UserId } });
    this.dialog.closeAll();
  }

  getAmountGraphData(dates1?:any) {
    this.isLoading = true;
    this.receiptGraphObj = { 'Fresh': 0, 'Land Record': 0, 'Renewal': 0, 'Top UP': 0 };

    this.generalService.getAmountGraphData(this.currentUser.franchise_Id, dates1).subscribe((res: any) => {
      if (res) {
        this.isLoading = false;
        this.amountGraphDate = res.data;
        let temp = Object.values(this.amountGraphDate);
        temp.map((i: any) => {
          this.receiptGraphObj[i.receipt_type] = i.amount;
        })
        this.series2 = temp.map((i: any) => i.amount);
        if(res.data.length ===  0){
          this.receiptGraphObj = { 'Fresh': 0, 'Land Record': 0, 'Renewal': 0, 'Top UP': 0 };

           this.series2 = [25,25,25,25]
        }
        this.setChartData2();
      }
    },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      })
  }


  setChartData(type: any , series: any[], labels: any[],color:any[],) {
    return {
      type: 'donut',
      height: 260,
      series,
      labels,
      colors: color,
      dataLabels: {
        enabled: true,
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return ''
          },
          title: {
            formatter: function (series) {
              return series
            }
          },
        }
      },
      legend: {
         show: true,
        position: 'bottom',
        horizontalAlign: 'center',
      },
      options: {
        maintainAspectRatio: false,
        cutoutPercentage: 70,
        legend: {
          display: true
         }
      }
    };
  }

  setChartData1() {
    if(this.usersCount['status_wise_count'] && this.usersCount['status_wise_count'].length===0){
      let  colors = ['#26c6e1','#26c6e1','#26c6e1', '#26c6e1' ]
      this.ChartType1 = this.setChartData('pie', ['100'], Object.entries(this.userGraphObj).map(([key,value])=>`${key}- ${value}`), colors);
    }else{
      let  colors = ['#0012fa', '#DC143C', '#00d989', '#9483de', '#fe8b02', '#b2d897']
      this.ChartType1 = this.setChartData('pie', Object.values(this.userGraphObj), Object.entries(this.userGraphObj).map(([key, value]) => `${key}- ${value}`), colors);  }
    }
  setChartData2() {
    if(this.amountGraphDate && this.amountGraphDate.length===0){
      let  colors = ['#26c6e1','#26c6e1','#26c6e1', '#26c6e1' ]
     this.ChartType2 = this.setChartData('pie', ['100'], Object.entries(this.receiptGraphObj).map(([key,value])=>`${key}- ${value}`), colors);
    }
    else{
      let  colors = ['#26c6e1', '#6658dd', '#d9847e', '#DC143C', '#9483de', '#00ff5b']
      this.ChartType2 = this.setChartData('pie', Object.values(this.receiptGraphObj), Object.entries(this.receiptGraphObj).map(([key,value])=>`${key}- ${value}`),colors);
    }
  }


  selectedDate(value: any) {
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    let startDate = new Date( this.daterange.start );
    let endDate = new Date(this.daterange.end );
    const formattedStartDate = `${startDate.getFullYear()}/${(startDate.getMonth() + 1).toString().padStart(2, '0')}/${startDate.getDate().toString().padStart(2, '0')}`; 
    const formattedEndDate = `${endDate.getFullYear()}/${(endDate.getMonth() + 1).toString().padStart(2, '0')}/${endDate.getDate().toString().padStart(2, '0')}`;
    // this.getCalenderType(this.daterange);
    let dates = { endDate: formattedEndDate, startDate: formattedStartDate };
    this.dates = dates;
    this.dateRangeValue = formattedStartDate + '-' + formattedEndDate
      this.getCountOfUser(dates);
      this.getAmountGraphData(dates)
  }

  getCalenderType(daterange) {
    let startDate = new Date( daterange.start );
    let endDate = new Date( daterange.end );
    const formattedStartDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`; 
    const formattedEndDate = `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`;
    this.generalService.getCalenderRange(formattedStartDate,formattedEndDate).subscribe((res: any) => {
      if (res) {
        this.usersCount = res.data;
        this.setCount(this.usersCount['status_wise_count']);
        let dates = { endDate:formattedEndDate , startDate: formattedStartDate };
      this.getCountOfUser(dates);
      this.getAmountGraphData(dates)
      }
    },
      (error) => {
        // this.loading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
          timer: 1500,
          showConfirmButton:false
        });
      })
  }


  resetForm(form: any){
    form.reset();
    this.name = '';
    this.getCountOfUser();
    this.getAmountGraphData();

  }
  datechange(){
    let dateRange =document.getElementById('daterangeInput');
   
    if(dateRange){
      dateRange.click()
      this.getAmountGraphData();

    }
  
  }
  onLikeClicked(status:string){
   
      this.router.navigate(['users/users-users'], { state: { status: status, dates: this.dates } });
  }
}


